import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosInstance, AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {IContributionResponse} from '../../utils/types';
//services
import {OrganizationAttendeesContributionsService} from '@/utils/services/organization-attendeesContributions';

//helpers
import {getErrorResponse} from '@/utils/helpers';

export const getAttendeesContributions = createAsyncThunk(
	ACTION_TYPE.ATTENDEE_CONTRIBUTIONS_LIST,
	async ({attendeeId, apiInstance}: {attendeeId: number; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const attendeesResponse: AxiosResponse<IContributionResponse> =
				await OrganizationAttendeesContributionsService.getAttendeesContributionsList(attendeeId, apiInstance);

			return attendeesResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
